import http from './http';

export const getSiteManagers = async () => {
  const { data } = await http.get('/site_managers');
  return data;
};

export const postSiteManagers = async (data) => {
  const response = await http.post('/site_managers', data);
  return response.data;
};

export const deleteSiteManager = async (id) => {
  const response = await http.delete(`/site_managers/${id}`);
  return response.data;
};
